<app-confirmation-modal
  title="Opening Source"
  confirmText="Continue"
  cancelText="Cancel"
  (cancel)="cancel()"
  (confirm)="confirm()"
>
  <p class="body-text">
    You’re about to leave flip* and open the original source in your browser.
  </p>
</app-confirmation-modal>
